module.exports = __webpack_public_path__ + "img/empty.5411ef7a.png";